import { useIsDesktop } from '@cian/valuation-utils-component';
import { useSelector } from 'react-redux';

import { selectPageType } from '../../../selectors';
import { EPageType } from '../../../types/page/pageType';
import { TTheme } from '../../../types/page/theme';
import AGENT_BG from '../assets/agent_bg.png';
import HOMEOWNER_BG from '../assets/homeowner_bg.svg';
import MOBILE_TENANT_BG from '../assets/mobile_tenant_bg.svg';
import DESKTOP_TENANT_BG from '../assets/tenant_bg.svg';

export function useGetContent() {
  const pageType = useSelector(selectPageType);
  const isDesktop = useIsDesktop();

  const TENANT_BG = isDesktop ? DESKTOP_TENANT_BG : MOBILE_TENANT_BG;

  switch (pageType) {
    case EPageType.Homeowner:
      return {
        heading: 'Подпишите договор аренды онлайн',
        title:
          'Покажите, что готовы подписать договор аренды онлайн — объявление привлечёт больше внимания, а вы избавитесь от правовых рисков',
        background: HOMEOWNER_BG,
        theme: 'homeowner-bg' as TTheme,
      };
    case EPageType.Tenant:
      return {
        heading: 'Снимите квартиру по онлайн-договору',
        title: 'Подпишите договор через Госуслуги — это надёжно, быстро и полностью удалённо',
        background: TENANT_BG,
        theme: 'tenant-bg' as TTheme,
      };
    case EPageType.Agent:
      return {
        heading: 'Предложите клиентам онлайн-договор аренды',
        title: 'Меньше бюрократии для вас, больше уверенности — для них',
        background: AGENT_BG,
        theme: 'agent-bg' as TTheme,
      };
  }
}
